import React from "react";
import {
  geterrorCodeSolution,
  getLanguageVerionBy,
  getErrorCodeSolutionDetail,
} from "../../ajax/index";
import { NavBar, Icon, Toast } from "antd-mobile";
import { Link } from "react-router-dom";
import homeimg from "../../assets/images/home/icon_home_dark.png";
import {
  getDocDownloadUrl,
  getLog,
  getPath,
  getBlobUrl,
  getPath2,
} from "../../ajax/index.js";
import ExplodedView from "../../components/ExplodedView.js";
import { changeMeta } from "../../common/Method.js";
import { createHashHistory } from "history";
const history = createHashHistory();
// 动态添加meta
function DocComponent(props) {
  switch (props.doctype) {
    case "pdf":
      return (
        <div>
          <ExplodedView path={props.path} key="pdf" />
        </div>
      );
    case "png":
      return (
        // <div>
        //   <ExplodedView path={props.path} key="pdf" />
        // </div>
        <div>
          <img src={props.path} width="100%" height="" alt="" key="png" />
        </div>
      );
    case "video":
      return (
        <div>
          <video width="100%" height="240" controls key="video">
            <source src={props.path} type="video/mp4"></source>
            <source src={props.path} type="video/ogg"></source>
            <source src={props.path} type="video/quicktime"></source>
          </video>
        </div>
      );
    default:
      break;
  }
}
class Solution extends React.Component {
  constructor(porps) {
    super(porps);
    this.state = {
      solutionData: {},
      // solutionLanguageList: [],
      tspErrorCodeSolution: [],
      docId: "",
      pictureId: "",
      videoId: "",
      path: "",
      // languageName: '',
    };
  }

  getPath = (id) => {
    getPath(id).then((res) => {
      console.log(res.data, "res.data");
      this.setState({
        path: res.data.downloadUrl,
      });
    });
  };

  getPath2 = (id) => {
    // getBlobUrl(id).then((res) => {
    //   const blob = new Blob([res]);
    //   const reader = new FileReader();
    //   reader.readAsDataURL(blob);
    //   reader.onload = (e) => {
    //     let href = window.URL.createObjectURL(blob); //创建下载的链接
    //     console.log("href", href);
    //     // callback && callback(href);
    //     this.setState({
    //       path: href,
    //     });
    //   };
    getPath(id).then((res) => {
      console.log(res.data.downloadUrl, "res333");
      this.setState({
        path: res.data.downloadUrl,
      });
      // window.open(res.data.downloadUrl);
      // const blob = new Blob([res]);
      // let url = window.URL.createObjectURL(blob);
      // console.log(url, "url");
      // this.setState({
      //   path: url,
      // });
    });
  };
  // getdocData = (getsolutionId, language) => {
  //   getLanguageVerionBy(getsolutionId, language).then((res) => {
  //     this.setState({
  //       docId: res.data[0].docId,
  //       pictureId: res.data[0].pictureId,
  //       videoId: res.data[0].videoId,
  //       // languageName: res.data.language
  //     });
  //   });
  // };
  componentDidMount() {
    const params = this.props.match.params.solutionId.split(",");
    const solutionId = params[0];
    const language = params[1];
    let id = params[5];
    let currentUrl = window.location.href;
    let appId = "tsp.errorcode";
    let pointName = `/Solution`;
    getLog(currentUrl, appId, pointName);

    getErrorCodeSolutionDetail(solutionId, language).then((res) => {
      console.log(res, "getErrorCodeSolutionDetail");
      this.setState({
        solutionData: res.data || {},
      });
    });
    // this.getdocData(solutionId, language);
    // this.getPath2(id);
    // 读取本地缓存
    // let language = localStorage.getItem('language');
    // if (language) {
    //   this.getdocData(getsolutionId, language);
    // }
    // else {
    //   //获取浏览器语言
    //   let language = navigator.language.slice(0, 2);
    //   this.getdocData(getsolutionId, language);

    // }

    // geterrorCodeSolution(solutionId, language).then((res) => {
    //   if (res.data === null) {
    //     Toast.fail("暂无解决方案");
    //   } else {
    //     this.setState({
    //       solutionData: res.data,
    //       // solutionLanguageList: res.data.solutionLanguageList,
    //       tspErrorCodeSolution: res.data,
    //     });
    //   }
    // });
  }

  back() {
    history.goBack();
  }
  onClick() {}
  selectonChange = (e) => {
    e.persist();
    let doctype = e.target.value;
    this.setState({
      doctype: doctype,
    });
  };
  render() {
    // console.log(this.state.docId, 'docid', this.state.languageName)
    changeMeta(this.props.match.path);
    let params = this.props.match.params.solutionId.split(",");
    let doctype = params[2];
    let content = this.state.solutionData.content || "";
    let name = this.state.solutionData.name;
    let id = params[3];

    // getBlobUrl(id).then((res) => {
    //   // let url = window.URL.createObjectURL(new Blob([res]));
    //   // console.log(res, "res3333");
    //   // console.log(url, "66666");
    //   const fileReader = new FileReader();
    //   const blob = res;
    //   fileReader.readAsArrayBuffer(blob);
    //   fileReader.onload = (e) => {
    //     const href = window.URL.createObjectURL(blob); // 创建下载的链接
    //     console.log(href);
    //   };
    // });
    // switch (doctype) {
    //   case "pdf":
    //     id = this.state.docId;
    //     break;
    //   case "png":
    //     id = this.state.pictureId;
    //     break;
    //   case "video":
    //     id = this.state.videoId;
    //     break;
    //   default:
    //     break;
    // }
    // let path = "/tsp/ibos/web/tspApi/macroFilePdf?fileGuid=" + id;
    let path = "/tsp/ibos/web/tspApi/file/download/anonymity/" + id;
    // if (doctype == "video") {
    //   path =
    //     // "https://ibs-sit.midea.com/web/ibos-tsp/file/download/a3a6ea3f6564459d948513ba707d9a65?loginId=yubin29";
    //     path = this.state.path;
    // }
    console.log(path, "path9999999");
    const nopic = require("../../assets/images/home/img_null.png");
    return (
      <div className="transition-item detail-page">
        <div className="menu-style">
          <NavBar
            mode="light"
            icon={<Icon type="left" />}
            onLeftClick={this.back}
            rightContent={[
              <Link to="/">
                <img src={homeimg} width="24" height="24" alt="homeing" />
              </Link>,
            ]}
          >
            Solution
          </NavBar>
          <div
            className="content pdf pdf-content"
            style={{ padding: "10px 10px" }}
          >
            <div>
              <div className="solution-title">{name}</div>
              <p className="solution-content"> {content}</p>
            </div>
            {id ? (
              <DocComponent doctype={doctype} path={path} />
            ) : (
              <img src={nopic} width="100%" />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Solution;



// WEBPACK FOOTER //
// ./src/pages/Home/Solution.js